<template>
  <v-app-bar 
    dark
    v-on:click="nytClick" 
    v-bind:height=windowHeight
    v-bind:width=windowWidth
  >
    <template v-slot:img="{ props  }">
      <img v-if="clicked"
        fill-height
        fill-width
        v-bind:src=imageurl
        v-bind:height=windowHeight
        v-bind:width=windowWidth
      >
      <v-img
        v-bind="props"
        v-bind:height=windowHeight
        v-bind:width=windowWidth
      ><center>width = {{ windowWidth }}, height = {{ windowHeight }}</center>
      <!-- <div class="image-annotation__marker" :style="markerStyle" /> -->
      <!-- <v-icon
        color="red"
        icon="mdi-target"
        size="x-large">mdi-target</v-icon> -->
      </v-img>
    </template>

    <v-spacer></v-spacer>
    <div v-if = "!clicked"><b>click somewhere...</b></div>
    <v-spacer></v-spacer>

      <!-- <Main/> -->
  </v-app-bar>
</template>

<script>
// import Main from './components/Main';
  import defaultfar from "@/assets/bg/defaultfar.png"
  import portait from "@/assets/bg/portrait.png"

  // Kvadrantbilleder
  import L101 from "@/assets/bg/landscape/L101.png"
  import L102 from "@/assets/bg/landscape/L102.png"
  import L103a from "@/assets/bg/landscape/L103a.png"
  import L103b from "@/assets/bg/landscape/L103b.png"
  import L103c from "@/assets/bg/landscape/L103c.png"
  import L103d from "@/assets/bg/landscape/L103d.png"
  import L103e from "@/assets/bg/landscape/L103e.png"
  import L103f from "@/assets/bg/landscape/L103f.png"
  import L103g from "@/assets/bg/landscape/L103g.png"
  import L103h from "@/assets/bg/landscape/L103h.png"
  import L103i from "@/assets/bg/landscape/L103i.png"
  import L104 from "@/assets/bg/landscape/L104.png"
  import L105 from "@/assets/bg/landscape/L105.png"
  import L106 from "@/assets/bg/landscape/L106.png"
  import L107 from "@/assets/bg/landscape/L107.png"
  import L108 from "@/assets/bg/landscape/L108.png"



  import L200 from "@/assets/bg/landscape/L200.png"
  import L201 from "@/assets/bg/landscape/L201.png"
  import L202 from "@/assets/bg/landscape/L202.png"
  import L203 from "@/assets/bg/landscape/L403203.png"
  import L204 from "@/assets/bg/landscape/L204.png"
  import L205 from "@/assets/bg/landscape/L205.png"
  import L206 from "@/assets/bg/landscape/L206.png"
  import L207 from "@/assets/bg/landscape/L207.png"
  import L208 from "@/assets/bg/landscape/L208.png"
  import L209 from "@/assets/bg/landscape/L209.png"
  import L210 from "@/assets/bg/landscape/L210.png"
  import L211 from "@/assets/bg/landscape/L211.png"



  import L301 from "@/assets/bg/landscape/L301.png"
  import L302 from "@/assets/bg/landscape/L302.png"
  import L303 from "@/assets/bg/landscape/L303.png"
  import L304 from "@/assets/bg/landscape/L304.png"
  import L305 from "@/assets/bg/landscape/L305.png"
  import L306 from "@/assets/bg/landscape/L306.png"
  import L307 from "@/assets/bg/landscape/L307.png"
  import L308 from "@/assets/bg/landscape/L308.png"
  import L309 from "@/assets/bg/landscape/L309.png"
  import L310 from "@/assets/bg/landscape/L310.png"
  import L311 from "@/assets/bg/landscape/L311.png"
  import L312 from "@/assets/bg/landscape/L312.png"
  import L313 from "@/assets/bg/landscape/L313.png"
  import L314 from "@/assets/bg/landscape/L314.png"
  import L315 from "@/assets/bg/landscape/L315.png"



  import L401 from "@/assets/bg/landscape/L401.png"
  import L402 from "@/assets/bg/landscape/L402.png"
  import L403 from "@/assets/bg/landscape/L403203.png"
  import L404 from "@/assets/bg/landscape/L404.png"
  import L405 from "@/assets/bg/landscape/L405.png"
  import L406 from "@/assets/bg/landscape/L406.png"
  import L407 from "@/assets/bg/landscape/L407.png"
  import L408 from "@/assets/bg/landscape/L408.png"
  import L409 from "@/assets/bg/landscape/L409.png"
  import L410 from "@/assets/bg/landscape/L410.png"
  import L411 from "@/assets/bg/landscape/L411.png"
  import L412 from "@/assets/bg/landscape/L412.png"
  import L413 from "@/assets/bg/landscape/L413.png"
  import L414 from "@/assets/bg/landscape/L414.png"
  import L415 from "@/assets/bg/landscape/L415.png"
  import L416 from "@/assets/bg/landscape/L416.png"
  import L417 from "@/assets/bg/landscape/L417.png"
  import L418 from "@/assets/bg/landscape/L418.png"
  import L419 from "@/assets/bg/landscape/L419.png"



  import P1 from "@/assets/bg/portrait/P1.png"
  import P2 from "@/assets/bg/portrait/P2.png"
  import P3 from "@/assets/bg/portrait/P3.png"
  import P4 from "@/assets/bg/portrait/P4.png"


export default {
  name: 'App',

  components: {
    // Main,
  },

  data: () => ({
      clicked: false,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newpic: false,
      imageurl: ''
  }),

    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
    },

    beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
    },

    methods: {  
      onResize() {
        this.windowHeight = window.innerHeight
        this.windowWidth = window.innerWidth
      },
      nytClick(event) {
        this.clicked = true
        this.x = event.clientX
        this.y = event.clientY
        console.log("relX: " + event.clientX/this.windowWidth + ", relY: " + event.clientY/this.windowHeight)
        console.log("X: " + event.clientX + ", Y: " + event.clientY)
        this.findBillede(this.x/this.windowWidth, this.y/this.windowHeight)
      },

      // TODO: find ud ad om vi kan lave en dynamisk markør, der sætter et ikon hvor der senest er blevet klikket
      // markerStyle() {
      //   if (this.activeCoordinates === null) return { display: 'none' }

      //   return {
      //     top: `${this.activeCoordinates.y}px`,
      //     left: `${this.activeCoordinates.x}px`,
      //   }
      // },


      findBillede(relX, relY) {
        if (relX > 2) { console.log(defaultfar) }
        this.imageurl = ''

        if (this.windowWidth > this.windowHeight) {           // Landscape

        if (relX >= 0.3125 && relY >= 0.377777778 && relX < 0.4 && relY < 0.888888889) {
          this.imageurl = L205
        }

        if (relX >= 0.5375 && relY >= 0.718518519 && relX < 0.60625 && relY < 0.8) {
          this.imageurl = L413
        }
        if (relX >= 0.571875 && relY >= 0.759259259 && relX < 0.640625 && relY < 0.840740741) {
          this.imageurl = L413
        }
        if (relX >= 0.46875 && relY >= 0.637037037 && relX < 0.5375 && relY < 0.718518519) {
          this.imageurl = L413
        }
        if (relX >= 0.503125 && relY >= 0.677777778 && relX < 0.571875 && relY < 0.759259259) {
          this.imageurl = L413
        }
        if (relX >= 0.4 && relY >= 0.555555556 && relX < 0.46875 && relY < 0.637037037) {
          this.imageurl = L413
        }
        



          if (relX >= 0.5){          
            if (relY >= 0.5) {       // 4. Kvadrant


              if (relX >= 0.894791667 && relX <= 0.933333333 && relY < 0.809917355 && relY > 0.723140496) {
                this.imageurl = L401
              }
              if (relX >= 0.6 && relX <= 0.85 && relY > 0.733333333 && relY < 0.777777778) {
                this.imageurl = L402
              }
              if (relX >= 0.575 && relX <= 0.8125 && relY >= 0.888888889 ) {
                this.imageurl = L403
              }
              if (relX >= 0.65 && relX <= 0.76875 && relY >=  0.555555556 && relY < 0.688888889) {
                this.imageurl = L404
              }
              if (relX >= 0.575 && relY >= 0.711111111 && relX < 0.7 && relY < 0.755555556) {
                this.imageurl = L405
              }
              if (relX >= 0.93125 && relY >= 0.555555556 && relY < 0.77777777) {
                this.imageurl = L406
              }
              if (relX >= 0.60625 && relX < 0.688888889 && relY >= 0.6375 && relY < 0.755555556) {
                this.imageurl = L407
              }
              if (relX >= 0.5125 && relY >= 0.933333333 && relX < 0.575 && relY < 1) {
                this.imageurl = L408
              }
              if (relX >= 0.8125 && relY >= 0.888888889 && relX < 0.875 && relY < 1) {
                this.imageurl = L409
              }
              if (relX >= 0.75 && relY >= 0.822222222 && relX < 0.875 && relY < 0.888888889) {
                this.imageurl = L410
              }
              if (relX >= 0.5 && relY >= 0.8 && relX < 0.75 && relY < 0.888888889) {
                this.imageurl = L411
              }
              if (relX >= 0.875 && relY >= 0.822222222 && relX < 0.96875 && relY < 1) {
                this.imageurl = L412
              }
              if (relX >= 0.76875 && relY >= 0.6 && relX < 0.8 && relY < 1) {
                this.imageurl = L414
              }
              if (relX >= 0.8 && relY >= 0.488888889 && relX < 0.90625 && relY < 0.6) {
                this.imageurl = L415
              }
              if (relX >= 0.8 && relY >= 0.6 && relX < 0.85 && relY < 0.688888889) {
                this.imageurl = L416
              }
              if (relX >= 0.5625 && relY >= 0.555555556 && relX < 0.5875 && relY < 0.622222222) {
                this.imageurl = L417
              }
              if (relX >= 0.575 && relY >= 0.588888889 && relX < 0.6 && relY < 0.655555556) {
                this.imageurl = L417
              }
              if (relX >= 0.5875 && relY >= 0.622222222 && relX < 0.6125 && relY < 0.688888889) {
                this.imageurl = L417
              }
              if (relX >= 0.5125 && relY >= 0.888888889 && relX < 0.575 && relY < 0.933333333) {
                this.imageurl = L418
              }
              if (relX >= 0.6375 && relY >= 0.777777778 && relX < 10.0 && relY < 0.8) {
                this.imageurl = L419
              }


              
              
              












            } else { // 1. kvadrant
              
              if (relX >= 0.7760416666666666 && relY >= 0.15082644628099173 && relX < 0.809375 && relY < 0.2231404958677686) {
                this.imageurl = L101
              }
              if (relX >= 0.68125 && relY >= 0.0 && relX < 0.71875 && relY < 0.244444444) {
                this.imageurl = L102
              }
              if (relX >= 0.53125 && relY >= 0.333333333 && relX < 0.6875 && relY < 0.444444444) {
                this.imageurl = L104
              }
              if (relX >= 0.5 && relY >= 0.355555556 && relX < 0.53125 && relY < 0.4) {
                this.imageurl = L106
              }
              if (relX >= 0.7925 && relY >= 0.115555556 && relX < 0.8275 && relY < 0.186666667) {
                this.imageurl = L101
              }
              if (relX >= 0.81 && relY >= 0.08 && relX < 0.845 && relY < 0.151111111) {
                this.imageurl = L101
              }
              if (relX >= 0.8275 && relY >= 0.044444444 && relX < 0.8625 && relY < 0.115555556) {
                this.imageurl = L101
              }
              if (relX >= 0.65 && relY >= 0.266666667 && relX < 0.69375 && relY < 0.3) {
                this.imageurl = L107
              }

            }
            if (relX >= 0.775 && relY >= 0.377777778 && relX < 0.8125 && relY < 0.666666667) {
              this.imageurl = L108
            }



          } else {
            if (relY >= 0.5) {       // 3. kvadrant


              if (relX >= 0.23333333333333334 && relY >= 0.722222222 && relX < 0.3541666666666667 && relY < 0.8429752066115702) {
                this.imageurl = L301
              }
              if (relY >= 0.77 && relX >= 0.25 && relX < 0.33) {
                this.imageurl = L302
              }
              if (relX >= 0.3 && relY >= 0.9 && relX < 0.31875 && relY < 1) {
                this.imageurl = L303
              }
              if (relX >= 0 && relY >= 0.9 && relX < 0.10625 && relY < 1) {
                this.imageurl = L304
              }
              if (relY >= 0.6 && relX < 0.3125 && relY < 0.722222222) {
                this.imageurl = L305
              }
              if (relX >= 0.1375 && relY >= 0.9 && relX < 0.18125) {
                this.imageurl = L306
              }
              if (relX >= 0.3625 && relY >= 0.826666667 && relX < 0.4 ) {
                this.imageurl = L308
              }
              if (relX >= 0.18125 && relY >= 0.9 && relX < 0.20625) {
                this.imageurl = L309
              }
              if (relX >= 0.10625 && relY >= 0.9 && relX < 0.1375) {
                this.imageurl = L310
              }
              if (relY >= 0.722222222 && relX <= 0.25 && relY <= 0.9) {
                this.imageurl = L311
              }
              if (relX >= 0.0275 && relY >= 0.755555556 && relX < 0.05 && relY < 0.788888889) {
                this.imageurl = L307
              }
              if (relX >= 0.3125 && relY >= 0.6 && relX < 0.425 && relY <= 0.722222222) {
                this.imageurl = L312
              }
              if (relX >= 0.20625 && relY >= 0.9 && relX < 0.25 && relY <= 200.0) {
                this.imageurl = L314
              }
              if (relX >= 0.33 && relY >= 0.644444444 && relX < 0.5 && relY <= 1) {
                this.imageurl = L315
              }

            } else { // 2. kvadrant
              
              
              if (relX >= 0.261458333 && relY >= 0. && relX < 0.3125 && relY < 0.440082645) {
                this.imageurl = L200
              }  
              if (relX >= 0.35 && relX <= 0.3875 && relY > 0.04 && relY < 0.0875) {
                this.imageurl = L201
              }
              if (relX >= 0.24375 && relY >= 0.411111111 && relX < 0.28125 && relY < 0.488888889) {
                this.imageurl = L202
              }
              if (relX >= 0.357 && relY >= 0.1333333333 && relX < 0.5125 && relY < 0.1888889) {
                this.imageurl = L203
              }
              if (relX >= 0 && relY >= 0 && relX < 0.03125 && relY < 0.033333333) {
                this.imageurl = L206
              }
              if (relX >= 0.4 && relY >= 0.4 && relX < 0.45 && relY < 0.4666666666666667) {
                this.imageurl = L209
              }
                    


            }
          }





        } else {                                                // Portrait


          this.imageurl = portait


          console.log(P1,P2,P3,P4)


        }



        if (relX >= 0.95) {
          if (relY <= 50/450){this.imageurl = L103a}
          else if (relY <= 100/450){this.imageurl = L103b}
          else if (relY <= 150/450){this.imageurl = L103c}
          else if (relY <= 200/450){this.imageurl = L103d}
          else if (relY <= 250/450){this.imageurl = L103e}
          else if (relY <= 300/450){this.imageurl = L103f}
          else if (relY <= 350/450){this.imageurl = L103g}
          else if (relY <= 400/450){this.imageurl = L103h}
          else if (relY <= 450/450){this.imageurl = L103i}
        }

        if (relX >= 0.18125 && relY >= 0.2 && relX < 0.2125 && relY < 0.6) {
          this.imageurl = L204
        }
        if (relX >= 0.4 && relY >= 0.888888889 && relX <= 0.5125 ) {
          this.imageurl = L313
        }
        if (relX >= 0.5125 && relY >= 0.4 && relX < 0.53125 && relY < 0.555555556) {
          this.imageurl = L105
        }
        if (relX >= 0.25 && relY >= 0.488888889 && relX < 0.3125 && relY < 0.6) {
          this.imageurl = L207
        }
        if (relX >= 0.2125 && relY >= 0.466666667 && relX < 0.28125 && relY < 0.555555556) {
          this.imageurl = L208
        }
        if (relX >= 0.25 && relY >= 0.422222222 && relX < 0.3125 && relY < 0.511111111) {
          this.imageurl = L208
        }
        if (relX >= 0 && relY >= 0.555555556 && relX < 0.18125 && relY < 0.6) {
          this.imageurl = L210
        }
        if (relX >= 0.15625 && relY >= 0.515555556 && relX < 0.1875 && relY < 0.555555556) {
          this.imageurl = L211
        }
        if (relX >= 0.14375 && relY >= 0.488888889 && relX < 0.16875 && relY < 0.533333333) {
          this.imageurl = L211
        }
        if (relX >= 0.135 && relY >= 0.471111111 && relX < 0.15625 && relY < 0.515555556) {
          this.imageurl = L211
        }
        if (relX >= 0.12125 && relY >= 0.444444444 && relX < 0.14375 && relY < 0.488888889) {
          this.imageurl = L211
        }
        if (relX >= 0.11125 && relY >= 0.433333333 && relX < 0.135 && relY < 0.471111111) {
          this.imageurl = L211
        }
        if (relX >= 0.09875 && relY >= 0.404444444 && relX < 0.12125 && relY < 0.446666667) {
          this.imageurl = L211
        }
  
      }
      
    }


}

</script>
